import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { ChevronRightIcon, CrosshairIcon, TrophyIcon, TimerIcon, TreesIcon, UsersIcon, TargetIcon } from 'lucide-react';
function CowboyHatIcon({
  size = 64,
  style,
  className
}: {
  size?: number;
  style?: React.CSSProperties;
  className?: string;
}) {
  return <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" style={style} className={className} data-id="element-232">
      <path d="M6 42c0 0 4-3 26-3s26 3 26 3c0 2-6 5-26 5S6 44 6 42z" stroke="currentColor" strokeWidth="3.2" strokeLinecap="round" strokeLinejoin="round" data-id="element-233" />
      <path d="M16 42c0 0 1-8 3-14 1.5-4.5 3-7 5-9 2-2 5-3 8-3s6 1 8 3c2 2 3.5 4.5 5 9 2 6 3 14 3 14" stroke="currentColor" strokeWidth="3.2" strokeLinecap="round" strokeLinejoin="round" data-id="element-234" />
      <path d="M18 39c0 0 5-1.5 14-1.5s14 1.5 14 1.5" stroke="currentColor" strokeWidth="3.2" strokeLinecap="round" strokeLinejoin="round" data-id="element-235" />
      <path d="M32 35.5l1 2 2.2.3-1.6 1.5.4 2.2-2-1-2 1 .4-2.2-1.6-1.5 2.2-.3z" stroke="currentColor" strokeWidth="1.5" fill="currentColor" opacity="0.6" data-id="element-236" />
    </svg>;
}
function BowlingPinIcon({
  size = 64,
  style,
  className
}: {
  size?: number;
  style?: React.CSSProperties;
  className?: string;
}) {
  const pin = (cx: number) => <path d={`M${cx} 8 
        a4 4 0 1 1 0 8 a4 4 0 1 1 0-8
        M${cx - 1.5} 16 
        C${cx - 2} 20 ${cx - 4} 24 ${cx - 5.5} 30
        C${cx - 6.5} 34 ${cx - 6.5} 38 ${cx - 5} 42
        L${cx - 5} 48
        Q${cx - 5} 51 ${cx} 51
        Q${cx + 5} 51 ${cx + 5} 48
        L${cx + 5} 42
        C${cx + 6.5} 38 ${cx + 6.5} 34 ${cx + 5.5} 30
        C${cx + 4} 24 ${cx + 2} 20 ${cx + 1.5} 16`} stroke="currentColor" strokeWidth="3.2" strokeLinecap="round" strokeLinejoin="round" fill="none" data-id="element-237" />;
  return <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" style={style} className={className} data-id="element-238">
      {pin(32)}
    </svg>;
}
const activities = [{
  title: 'Sporting Clays',
  href: '/SportingClays.html',
  description: '17 stations on a one mile round heavily wooded course. Open to the public on weekends.',
  icon: CrosshairIcon
}, {
  title: 'Sporting Clays Scores & Events',
  href: '/SportingClaysScoresEvents.html',
  description: 'View the latest scores, upcoming leagues, and special events for Sporting Clays.',
  icon: TrophyIcon
}, {
  title: 'Cowboy Action Shooting',
  href: '/SASS.html',
  description: 'Single Action Shooting Society (SASS) period-correct competition. Dress the part and shoot the steel.',
  icon: CowboyHatIcon
}, {
  title: 'Steel Challenge',
  href: '/SteelChallenge.html',
  description: 'Speed shooting competition using steel targets. Open to members and the public.',
  icon: TimerIcon
}, {
  title: '3-D Archery',
  href: '/3DArchery.html',
  description: '30-target 3-D archery course set in the woods. Elevated shooting platforms and varied terrain.',
  icon: TreesIcon
}, {
  title: 'Jr. Rifle',
  href: '/JrRifle.htm',
  description: 'NRA-affiliated program for youth ages 10-18. Learn safe firearm handling and marksmanship.',
  icon: UsersIcon
}, {
  title: 'PPC Shooting',
  href: '/PPCShooting.html',
  description: 'Police Pistol Combat shooting. Precision shooting at various distances and positions.',
  icon: TargetIcon
}, {
  title: 'Bowling Pin Shoots',
  href: '/BowlingPinShoots.html',
  description: 'Fast-paced handgun competition shooting bowling pins off a table. Fun for all skill levels.',
  icon: BowlingPinIcon
}];
export function ActivitiesGrid() {
  return <div className="w-full py-12 md:py-16" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-239">
      <div className="max-w-6xl mx-auto px-4 md:px-8" data-id="element-240">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-241">
          {activities.map(activity => {
          const IconComponent = activity.icon;
          return <Link key={activity.href} to={activity.href} className="group flex flex-col bg-white rounded-xl overflow-hidden border shadow-sm transition-all hover:shadow-md hover:-translate-y-1" style={{
            borderColor: '#ede9e0'
          }} data-id="element-242">
                <div className="relative h-36 overflow-hidden flex items-center justify-center" style={{
              backgroundColor: '#1e3d2f'
            }} data-id="element-243">
                  <IconComponent size={64} strokeWidth={1.2} className="transition-transform duration-300 group-hover:scale-110" style={{
                color: '#c8a84b',
                opacity: 0.85
              }} data-id="element-244" />
                </div>
                <div className="p-5 flex-1 flex flex-col" data-id="element-245">
                  <h2 className="text-lg font-bold uppercase mb-2" style={{
                fontFamily: 'Oswald, sans-serif',
                color: '#1e3d2f'
              }} data-id="element-246">
                    {activity.title}
                  </h2>
                  <p className="text-sm flex-1 mb-4" style={{
                color: '#5a5a5a',
                fontFamily: 'Inter, sans-serif',
                lineHeight: '1.6'
              }} data-id="element-247">
                    {activity.description}
                  </p>
                  <div className="flex items-center gap-1.5 text-sm font-semibold transition-colors group-hover:text-[#c8a84b]" style={{
                color: '#1e3d2f',
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-248">
                    Learn More <ChevronRightIcon size={16} data-id="element-249" />
                  </div>
                </div>
              </Link>;
        })}
        </div>
      </div>
    </div>;
}